export const getCardTranslations = translate => ({
    soldOutLabel: translate('product_history.sold_out.label'),
    quantity: translate('shopcart.quantity.label'),
    comingSoon: translate('brandaz.coming-soon.label')
});
